module.exports = __webpack_public_path__ + "assets/img/digital-agency.ad050cd3.png";